import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import './DataManagementLoader.scss';

interface DataManagementLoaderProps {
  visible: boolean;
  label?: string;
}

const DataManagementLoader: React.FC<DataManagementLoaderProps> = ({ visible, label = 'Loading data' }) => {
  if (!visible) return null;

  return (
    <div className="dm-loading-overlay" role="status" aria-live="polite" aria-label={label}>
      <div className="dm-loading-content">
        <ProgressSpinner className="dm-loading-spinner" strokeWidth="5" />
        <span>{label}...</span>
      </div>
    </div>
  );
};

export default DataManagementLoader;